import { getAppStorageItem, setAppStorageItem } from './storageProxy';

// Site type shown in the navbar select. Values are what the backend expects.
export const SITE_TYPE_OPTIONS = [
  { label: 'Restaurant', value: 3, icon: 'mdi:silverware-fork-knife' },
  { label: 'Industrial', value: 2, icon: 'mdi:factory' },
  { label: 'Security & Safety', value: 4, icon: 'mdi:shield-check-outline' },
  { label: 'Automobile', value: 5, icon: 'mdi:car-outline' }
];

export const SITE_TYPE_STORAGE_KEY = 'site_type';

// Fired on every change so pages already mounted can refetch. Storage alone is
// read once at mount and would leave them showing the previous category.
export const SITE_TYPE_CHANGE_EVENT = 'site-type-change';

// First option in the list, so removing or reordering options cannot leave the
// default pointing at a value that is no longer offered.
export const DEFAULT_SITE_TYPE = SITE_TYPE_OPTIONS[0].value;

// Clients that get the navbar select. Every other client keeps the navbar as-is.
const SITE_TYPE_CLIENT_IDS = [1438];

export const isSiteTypeEnabled = (clientId) => SITE_TYPE_CLIENT_IDS.includes(Number(clientId));

// Current selection, falling back to the default when unset, corrupted, or set to
// an option that has since been removed.
export const getSiteType = () => {
  const stored = Number(getAppStorageItem(SITE_TYPE_STORAGE_KEY));
  return SITE_TYPE_OPTIONS.some((option) => option.value === stored) ? stored : DEFAULT_SITE_TYPE;
};

export const getSiteTypeOption = (value) =>
  SITE_TYPE_OPTIONS.find((option) => option.value === Number(value)) ||
  SITE_TYPE_OPTIONS.find((option) => option.value === DEFAULT_SITE_TYPE);

export const setSiteType = (value) => {
  setAppStorageItem(SITE_TYPE_STORAGE_KEY, String(value));
  window.dispatchEvent(new CustomEvent(SITE_TYPE_CHANGE_EVENT, { detail: Number(value) }));
};

// Only the clients that get the select send the parameter, so no other client's
// requests change shape. Spread into a request body/params object.
export const siteTypeParam = (clientId, value) =>
  (isSiteTypeEnabled(clientId) ? { event_category: Number(value) } : {});
